/**
 * @file 获取图片列表
 * @author liudy
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    element_id: number;
    sort_type: number; // number ｜ 点赞最多 commit ｜最新提交
    show_type: number; // todo 后端兼容，需要去掉
    student_id?: string;
    page?: number;
    size?: number;
}

export interface IPhotoInfo {
    photo_info: {
        id: string;
        photo_title: string;
        photo_url: {
            source: string;
            thumb: string;
            500: string;
            100: string;
            download: string;
        };
        photo_index: string;
        create_time: string;
        image_width: string;
        image_height: string;
        image_type: string;
        image_rotate: string;
        is_top: number;
    };
    like_info: {
        like_num: string;
        like: number; // 1 = 已经点赞 0 = 未点赞
        like_list?: IPhotoLikeList;
    };
    user_info: IUserBaseInfo;
    comment_info: {
        total: number;
    };
}

export const getPhotoList = (data: IInput): Promise<IListResponse<IPhotoInfo>> => {
    if (data.student_id) {
        return fetchData(Api.PHOTO_GET_PHOTOS_BY_USER, data).then((res: IListResponse<IPhotoInfo>) => {
            return res;
        });
    } else {
        return fetchData(Api.PHOTO_GET_PHOTOS, data).then((res: IListResponse<IPhotoInfo>) => {
            return res;
        });
    }
};
